import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import './Popup.css';

function Popup({ isOpen, title, message, onClose, variant = 'success', action = null }) {
  const closeRef = useRef(null);
  useEffect(() => {
    if (isOpen && closeRef.current) closeRef.current.focus();
  }, [isOpen]);
  if (!isOpen) {
    return null;
  }

  return createPortal(
    <div className="popup-overlay" onClick={onClose}>
      <div className={`popup-card popup-${variant}`} onClick={(e) => e.stopPropagation()}>
        <div className="popup-header">
          <h3>{title}</h3>
        </div>
        <p style={{ whiteSpace: 'pre-wrap' }}>{message}</p>
        {action}
        <button ref={closeRef} type="button" className="btn btn-primary popup-button" onClick={onClose}>
          Schliessen
        </button>
      </div>
    </div>,
    document.body
  );
}

export default Popup;
